function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "icomoon-ignore"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.113 11.279c-2.429 0-4.429 1.836-4.69 4.196h-1.080v1.049h1.080c0.261 2.36 2.261 4.196 4.69 4.196 2.607 0 4.721-2.113 4.721-4.721s-2.113-4.721-4.721-4.721zM13.113 19.672c-1.846 0-3.373-1.371-3.63-3.147h3.63v-1.049h-3.63c0.256-1.776 1.784-3.147 3.63-3.147 2.024 0 3.672 1.647 3.672 3.672s-1.647 3.672-3.672 3.672z",
  fill: "#000000"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.147 20.786v-3.147h-1.049v4.196h1.049z",
  fill: "#000000"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.147 13.377v-3.147h-1.049v4.196h1.049z",
  fill: "#000000"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.196 7.083v17.834h17.833v-17.834h-17.833zM20.98 23.868h-15.735v-15.735h15.735v15.735h0z",
  fill: "#000000"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 3.936v24.128h26.226v-24.128h-26.226zM25.177 27.015h-24.128v-22.029h24.128v22.029h-0z",
  fill: "#000000"
});

var SvgSafe = function SvgSafe(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSafe, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/safe.f4050d58.svg";
export { ForwardRef as ReactComponent };